import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

// This static object maps category names from your backend to the images for the UI.
// The images are taken from your original hardcoded list.
const categoryVisuals = {
    Health: { image: 'https://images.unsplash.com/photo-1505751172876-fa1923c5c528?q=80&w=870&auto=format&fit=crop' },
    Education: { image: 'https://images.unsplash.com/photo-1497633762265-9d179a990aa6?q=80&w=873&auto=format&fit=crop' },
    Running: { image: 'https://images.unsplash.com/photo-1476480862126-209bfaa8edc8?q=80&w=870&auto=format&fit=crop' },
    Jobs: { image: 'https://images.unsplash.com/photo-1556740738-b6a63e27c4df?q=80&w=870&auto=format&fit=crop' },
    Learning: { image: 'https://images.unsplash.com/photo-1541339907198-e08756dedf3f?q=80&w=870&auto=format&fit=crop' },
    Programming: { image: 'https://images.unsplash.com/photo-1542831371-29b0f74f9713?q=80&w=870&auto=format&fit=crop' },
    // A default image for any new categories from the backend that aren't in this list
    Default: { image: 'https://images.unsplash.com/photo-1522204523234-8729aa6e3d5f?q=80&w=870&auto=format&fit=crop' }
};

const Articles = () => {
  const [categories, setCategories] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    // The API endpoint to fetch category counts for articles.
    const apiUrl = '/api/summary/articles_counts_cat';

    fetch(apiUrl)
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then(data => {
        // Map the fetched data to include the corresponding image from categoryVisuals
        const formattedCategories = data.map(cat => ({
          ...cat, // Contains 'category' and 'count' from backend
          image: categoryVisuals[cat.category]?.image || categoryVisuals.Default.image
        }));
        setCategories(formattedCategories);
        setIsLoading(false);
      })
      .catch(error => {
        console.error('Error fetching article categories:', error);
        setError(error.message);
        setIsLoading(false);
      });
  }, []); // The empty dependency array ensures this effect runs once when the component mounts.

  if (isLoading) return <p className="text-center p-4">Loading categories...</p>;
  if (error) return <p className="error-message p-4">Error: {error}</p>;

  return (
    <div className="category-grid">
      {categories.map((category, index) => (
        <Link to={`/articles/category/${category.category}`} key={index} className="category-card-link">
          <div className="category-card" style={{ backgroundImage: `url(${category.image})` }}>
            <div className="category-card-overlay">
              <h3 className="category-card-title">{category.category} ({category.count})</h3>
            </div>
          </div>
        </Link>
      ))}
    </div>
  );
};

export default Articles;